
document.addEventListener('DOMContentLoaded', function () {
    let questions = document.querySelectorAll('.accordion__title');
    let answers = document.querySelectorAll('.accordion__content-wrap');
    let sidebarItems = document.querySelectorAll('.sidebar__item');
    const sidebarLinks = document.querySelectorAll('.faq__sidebar .sidebar__item-link');


    let currentActiveQuestion = '';
    questions.forEach((question, i) => {
        question.addEventListener('click', () => {
            if (currentActiveQuestion === i) {
                if (question.parentElement.classList.contains('main-questions__accordion--active')) {
                    hideAll();
                    question.parentElement.classList.remove('main-questions__accordion--active');
                } else {
                    question.parentElement.classList.add('main-questions__accordion--active');
                    showText(question.nextElementSibling);
                }
            } else {
                questions.forEach((question) => {
                    question.parentElement.classList.remove('main-questions__accordion--active');
                });
                hideAll();
                question.parentElement.classList.toggle('main-questions__accordion--active');
                showText(question.nextElementSibling);
            }
            currentActiveQuestion = i;
        });
    });

    function hideAll() {
        answers.forEach((answer) => {
            answer.style.height = '0';
        });
    }

    function showText(question) {
        if(question) question.style.height = question.scrollHeight + 'px';
    }

    sidebarItems.forEach(item => {
        item.addEventListener('click', function () {
            sidebarItems.forEach(otherItem => {
                otherItem.classList.remove('sidebar__item--active');
            });
            this.classList.add('sidebar__item--active');
        });
    });

    sidebarLinks.forEach(link => {
        link.addEventListener('click', function (event) {
            event.preventDefault();
            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);
            targetElement?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    });
});